import { useQuery } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { IGetComponentsQueryResponse } from "../utils/types";

const useGetComponentsQuery =
  (data: {hotelId: string}): IGetComponentsQueryResponse =>
    useQuery({
      queryKey: ["services-components", data.hotelId],
      queryFn: async () => {
        const response = await AXIOS_RESERVATION.get(
          "/getCategoryComponentWS3?isAdminPortal=true",
          {
            headers: {
              hotelId: data.hotelId
            }
          }
        );
        return response.data;
      },
    });

export default useGetComponentsQuery;
